import {
    enableProdMode,
    importProvidersFrom,
    provideZoneChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { Amplify } from 'aws-amplify';
import { parseAmplifyConfig } from 'aws-amplify/utils';
import awsconfig from './aws-exports';
import { applyRememberMeStorage } from './app/shared/services';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { DevExtremeModule } from 'devextreme-angular';
import moment from 'moment';
import 'moment/locale/th';

// Register the Thai locale (for Thai month/day names in printed documents)
// but keep the global default English so only explicit `.locale('th')`
// formatting switches to Thai.
moment.locale('en');

// No identity pool is configured, so Amplify never attempts
// GetCredentialsForIdentity and guest access cannot be requested. The previous
// `allowGuestAccess = false` workaround existed only to suppress a failing
// credentials call from the old identity pool, and is no longer needed.
Amplify.configure(parseAmplifyConfig(awsconfig));

// Restore the saved "remember me" choice so Cognito reads tokens from the same
// store (local vs session) they were written to on the previous sign-in.
applyRememberMeStorage();

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, DevExtremeModule),
        provideZoneChangeDetection(),
        { provide: LocationStrategy, useClass: HashLocationStrategy },
    ],
}).catch((err) => console.error(err));
